import { render, staticRenderFns } from "./DeviceConfig.vue?vue&type=template&id=d5ff360c"
import script from "./DeviceConfig.vue?vue&type=script&lang=js"
export * from "./DeviceConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports